/**
 * Util functions whose job is to save the landing information in cookies.
 */

import type { TDateTime } from '../../primitives/dates/date.types'
import { Cookie } from './Cookie'

export type TLandingInfo = {
  referrer: string
  landingUrl: string
  landingDate: Date
}

export const saveLandingInfo = (landingInfo: TLandingInfo) =>
  Cookie.set('landingInfo', JSON.stringify(landingInfo), 'oneMonth')

/**
 * Get landing information previously stored in cookies.
 */
export const getLandingInfo = () =>
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- JSON.parse stored value
  JSON.parse(Cookie.get('landingInfo') || 'null') as
    | (Omit<TLandingInfo, 'landingDate'> & { landingDate: TDateTime })
    | null
